import { UtilService } from './../../../shared/services/util.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { environment } from '@environments/environment';

import { FileUploader } from 'ng2-file-upload';

import { DocumentosService } from '@app/shared/services';
import { AuthenticationService } from '@app/shared/services';
import { AcompanhamentoService } from '@app/shared/services/acompanhamento.service';
import { RedirectService } from '@app/core/services/redirect.service';
import { MensagemService } from '@app/shared/services/mensagem.service';

import { Dependente, Documento, Servidor, Segurado, Status, Loading, Censo } from '@app/shared/models';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-contestacao',
  templateUrl: './contestacao.component.html',
  styleUrls: ['./contestacao.component.scss']
})
export class ContestacaoComponent implements OnInit {
  carregar = new Loading();

  cliente = environment.cliente;
  seguradoInformacoes: any = this.auth.currentUserValue;

  arquivo: any = {};
  uploader: FileUploader;

  servidor: Servidor = null;
  segurado: Segurado;
  dependentes: Dependente[] = [];

  btnHabilitado = true;

  documentosRejeitadosSegurado: any[] = [];
  documentosRejeitadosDependente: any[] = [];

  censo: Censo;

  constructor(
    private router: Router,
    private auth: AuthenticationService,
    private documentoService: DocumentosService,
    private acompanhamentoService: AcompanhamentoService,
    private redirectService: RedirectService,
    private mensagemService: MensagemService,
    private utilService: UtilService,
    private censoService: CensoService
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');
    this.moverParaURLCorreta();

    this.servidor = this.auth.currentUserValue;

    this.acompanhamentoService.status(this.carregar).subscribe((response: Status) => {
      if (response.documentosRejeitados === undefined || response.documentosRejeitados === null){
        return;
      }

      const DOCS_DEPENDENTES = response.documentosRejeitados.filter(a => a.dependente !== null);
      const DOCS_SEGURADO = response.documentosRejeitados.filter(a => a.segurado !== null);

      DOCS_DEPENDENTES.map(DOC => {
        const dependenteCadastrado = this.dependentes.find(a => a.id === DOC.dependente.id);
        if (!dependenteCadastrado) {
          this.dependentes.push({ ...DOC.dependente, documentos: [] });
          if (DOC?.documento?.id) {
            this.dependentes[this.dependentes.length - 1].documentos.push(
              { ...DOC.documento, dataEnvio: null, statusAtualArquivoEnviado: DOC.status }
            );
          }
        } else {
          const INDEX = this.dependentes.findIndex(a => a.id === DOC.dependente.id);
          this.dependentes[INDEX].documentos.push({ ...DOC.documento, dataEnvio: null, statusAtualArquivoEnviado: DOC.status });
        }
      });

      DOCS_SEGURADO.map(DOC => {
        const seguradoCadastrado = (this.segurado?.id) ? true : false;
        if (!seguradoCadastrado) {
          this.segurado = { ...DOC.segurado, documentos: [] };
          if (DOC?.documento?.id) {
            this.segurado.documentos.push({ ...DOC.documento, dataEnvio: null, statusAtualArquivoEnviado: DOC.status });
          }
        } else {
          this.segurado.documentos.push({ ...DOC.documento, dataEnvio: null, statusAtualArquivoEnviado: DOC.status });
        }
      });

      this.documentosRejeitadosSegurado = DOCS_SEGURADO;

      DOCS_DEPENDENTES.map(DOC => {
        const dependenteCadastrado = this.documentosRejeitadosDependente.find(a => a.id === DOC.dependente.id);

        if (!dependenteCadastrado) {
          this.documentosRejeitadosDependente.push({ ...DOC.dependente, documentos: [] });

          if (DOC?.documento?.id) {

            this.documentosRejeitadosDependente[this.documentosRejeitadosDependente.length - 1].documentos.push(
              { ...DOC.documento, contestacao: DOC.contestacao, statusAtualArquivoEnviado: DOC.status }
            );
          }
        } else {
          const INDEX = this.documentosRejeitadosDependente.findIndex(a => a.id === DOC.dependente.id);
          this.documentosRejeitadosDependente[INDEX].documentos.push({ ...DOC.documento, contestacao: DOC.contestacao, statusAtualArquivoEnviado: DOC.status });
        }
      });
    });
  }

  ngOnInit(): void {}

  finalizar(): void {
    this.acompanhamentoService.finalizar(this.carregar).subscribe(() => {
      this.router.navigate(['/acompanhamento']);
    });
  }

  selecionarArquivo(event: any, tipoPessoa: string, documento: Documento, idDependente?: number): any {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      // const file: File =
      this.arquivo = fileList[0];
    }

    const file = event.target.files[0];
    const tipo = file.type.split('/')[1];

    if (this.arquivo != null && this.arquivo.size / 5000000 > 10) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta('Arquivo ultrapassa os 50MB');
    }

    if (event.target.files && event.target.files.length <= 0) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta('Arquivo inválido/não encontrado');
    }

    if (!['jpg', 'jpeg', 'png', 'pdf'].includes(tipo)) {
      this.arquivo = null;
      return this.mensagemService.avisoMensagemAlerta('Arquivo não suportado');
    }

    const arquivoEnviado = new FormData();
    arquivoEnviado.append('arquivo', this.arquivo);

    if (tipoPessoa === 'DEPENDENTE') {
      this.dependentes.filter( dependente => dependente.id === idDependente).forEach(dependente => {
        dependente.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
          documentoLista.carregando = true;
          documentoLista.dataEnvio = null;
        });
      });
    }else {
      this.segurado.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
        documentoLista.carregando = true;
        documentoLista.dataEnvio = null;
      });
    }

    const params = {
      "contestacao": true,
      "tipoPessoa": tipoPessoa,
      "idDependente": idDependente
    }

    this.documentoService.enviarDocumento(arquivoEnviado, documento.id, params)
      .subscribe(response => {
        if (tipoPessoa === 'DEPENDENTE') {
          this.dependentes.filter( dependente => dependente.id === idDependente).forEach(dependente => {
            dependente.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
              documentoLista.dataEnvio = response.dataEnvio;
              documentoLista.idArquivoEnviado = response.idArquivoEnviado;
              documentoLista.carregando = false;
              this.verificaDocumentosObrigatorios();
            });
          });
        } else {
          this.segurado.documentos.filter(documentoLista => documentoLista.id === documento.id).forEach(documentoLista => {
            documentoLista.dataEnvio = response.dataEnvio;
            documentoLista.idArquivoEnviado = response.idArquivoEnviado;
            documentoLista.carregando = false;
            this.verificaDocumentosObrigatorios();
          });
        }
    });
  }

  formatarData(data: string): string {
    return this.utilService.formatarDataLonga(data);
  }

  verificaDocumentosObrigatorios(): void {
    let docSeguradoObrigatorio: any = this.segurado?.documentos.filter(
      documento => documento.obrigatorio === true && documento.dataEnvio === null
    );
    let docDependenteObrigatorio: Documento[] | any = [];

    this.dependentes.map(dependente => {
      docDependenteObrigatorio.push(
        ...dependente.documentos.filter(documento => documento.obrigatorio === true && documento.dataEnvio === null)
      );
    });

    if (docSeguradoObrigatorio === undefined || docSeguradoObrigatorio === null) {
      docSeguradoObrigatorio = false;
    } else if (docSeguradoObrigatorio?.length <= 0) {
      docSeguradoObrigatorio = false;
    } else {
      docSeguradoObrigatorio = true;
    }

    if (docDependenteObrigatorio === undefined || docDependenteObrigatorio === null) {
      docDependenteObrigatorio = false;
    } else if (docDependenteObrigatorio?.length <= 0) {
      docDependenteObrigatorio = false;
    } else {
      docDependenteObrigatorio = true;
    }

    if (!docSeguradoObrigatorio && !docDependenteObrigatorio) {
      this.router.navigate(['/acompanhamento']);
    }
  }

  logout(): void {
    this.mensagemService.avisoMensagemCondicional('', 'Você deseja realmente sair?', 'warning').then((response) => {
      if (response.value) {
        this.auth.logout();
        this.router.navigate(['/']);
      }
    });
  }

  moverParaURLCorreta(): void {
    this.redirectService.verificarEtapa(this.carregar).subscribe(([status, etapa]) => {
      if (status.documentosRejeitados?.length > 0 || status.identificacoesRejeitadas?.length > 0) {
        if (status.identificacoesRejeitadas?.length > 0) {
          this.redirectService.redirecionar(true, null, true);
        }else{
          this.redirectService.redirecionar(true, null, false);
        }
      } else {
        this.redirectService.redirecionar(false, etapa);
      }
    });
  }
}
